import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import App from "./App.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import * as logger from "./utils/logger";
import { initEcwidIframeViewport } from "./utils/ecwidViewport";

const ecwidAppId = import.meta.env.VITE_ECWID_APP_ID || "quote2-cart-dev";

const rootEl = document.getElementById("root");
const inIframe = window.self !== window.top;
if (rootEl) {
  rootEl.setAttribute("data-ecwid-app-id", ecwidAppId);
}
logger.log("[index] root element:", rootEl, "in iframe:", inIframe, "ecwidAppId:", ecwidAppId);
if (inIframe) {
  if (rootEl) rootEl.classList.add("ecwid-iframe");
  initEcwidIframeViewport(ecwidAppId);
}

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
logger.log("[index] App mounted");
